<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor">
    <path d="M1 11H3.48072L10.5091 3.97459C10.8293 3.64383 11.0067 3.20046 11.0029 2.74013C10.9992 2.27979 10.8147 1.83936 10.4891 1.51384C10.1636 1.18832 9.72319 1.0038 9.26285 1.00006C8.80251 0.996321 8.35915 1.17367 8.02839 1.49386L1 8.51928V11Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6.78809 2.73145L9.26881 5.21217" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
